import $ from 'jquery'

const slideClass = 'dhsv_vc_slider_container__slide'
const activeSlideClass = 'is-active'
const singleSlideClass = 'dhsv_vc_slider_container--single-slide'
const loadingClass = 'dhsv_vc_slider_container--is-loading'
const initializedClass = 'dhsv_vc_slider_container--is-initialized'

function getRows(track) {
  return Array.from(track.children).filter(child =>
    child.classList.contains('vc_row')
  )
}

function buildSlides(track) {
  const rows = getRows(track)

  return rows.map(row => {
    const slide = document.createElement('div')
    slide.className = slideClass
    track.insertBefore(slide, row)
    slide.appendChild(row)

    return slide
  })
}

function updateSlider({ slides, track, prevButton, nextButton, index, maxIndex }) {
  track.style.transform = `translate3d(-${index * 100}%, 0, 0)`
  slides.forEach((slide, slideIndex) => {
    slide.classList.toggle(activeSlideClass, slideIndex === index)
  })
  prevButton.disabled = index === 0
  nextButton.disabled = index === maxIndex
}

function initSliderContainer(container) {
  const track = container.querySelector('.js-dhsv-vc-slider-track')
  const prevButton = container.querySelector('.js-dhsv-vc-slider-prev')
  const nextButton = container.querySelector('.js-dhsv-vc-slider-next')

  if (!track || !prevButton || !nextButton) {
    return
  }

  const slides = buildSlides(track)

  if (slides.length <= 1) {
    container.classList.add(singleSlideClass)
    if (slides[0]) {
      slides[0].classList.add(activeSlideClass)
    }
    container.classList.remove(loadingClass)
    container.classList.add(initializedClass)
    return
  }

  const maxIndex = slides.length - 1
  let currentIndex = 0

  updateSlider({
    slides,
    track,
    prevButton,
    nextButton,
    index: currentIndex,
    maxIndex,
  })

  prevButton.addEventListener('click', () => {
    if (currentIndex === 0) {
      return
    }

    currentIndex -= 1
    updateSlider({
      slides,
      track,
      prevButton,
      nextButton,
      index: currentIndex,
      maxIndex,
    })
  })

  nextButton.addEventListener('click', () => {
    if (currentIndex === maxIndex) {
      return
    }

    currentIndex += 1
    updateSlider({
      slides,
      track,
      prevButton,
      nextButton,
      index: currentIndex,
      maxIndex,
    })
  })

  container.classList.remove(loadingClass)
  container.classList.add(initializedClass)
}

$(document).ready(function () {
  document
    .querySelectorAll('.js-dhsv-vc-slider-container')
    .forEach(initSliderContainer)
})
